import { motion } from "framer-motion";

import ecommerceIcon from "./assets/effi.svg";
import transportIcon from "./assets/res.svg";
import healthcareIcon from "./assets/comp.svg";
import agricultureIcon from "./assets/emp.svg";
import constructionIcon from "./assets/sat.svg";
import rentalIcon from "./assets/da.svg";

const CapacityBenefits = () => {
  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const staggerContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.25,
      },
    },
  };

  const industries = [
    {
      id: "execution-efficiency",
      icon: ecommerceIcon,
      title: "Execution Efficiency",
      desc: "All execution functions are easy and quick to expedite.",
    },
    {
      id: "resource-accuracy",
      icon: transportIcon,
      title: "Resource Accuracy",
      desc:
        "All change requests are accompanied by suggested eligible resources or available equipment.",
    },
    {
      id: "compliance",
      icon: healthcareIcon,
      title: "Compliance",
      desc: "Controls exist to ensure changes comply with rules.",
    },
    {
      id: "employee-satisfaction",
      icon: agricultureIcon,
      title: "Employee Satisfaction",
      desc:
        "Selection of resources based on eligibility ensures replacements are carried out without bias.",
    },
    {
      id: "safety",
      icon: constructionIcon,
      title: "Safety",
      desc:
        "Fatigue management and competency requirements are consistently adhered to when selecting resources changes.",
    },
    {
      id: "data-analysis",
      icon: rentalIcon,
      title: "Data Analysis",
      desc:
        "Maintaining accurate data on what, when and who ensures that accurate data is available for reporting as well as for auditing purposes.",
    },
  ];

  return (
    <section className="w-full py-16 font-epilogue bg-white">
      <div className="max-w-6xl mx-auto px-6 text-center">
      
        <motion.h2
          className="text-3xl md:text-4xl font-bold text-gray-900"
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          How it benefits your organization?
        </motion.h2>

      
        <motion.p
          className="mt-4 text-gray-600 max-w-2xl mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          Discover more JIVIEWS features
        </motion.p>

        <motion.div
          className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
        >
          {industries.map((item) => (
            <motion.div
              key={item.id}
              variants={fadeUp}
              className="relative group bg-white rounded-lg p-6 transition-all duration-300 hover:shadow-xl"
            >
             
              <span className="absolute top-0 left-0 w-0 h-[2px] bg-[#1E72BB] group-hover:w-full transition-all duration-500"></span>
              <span className="absolute top-0 right-0 w-[2px] h-0 bg-[#1E72BB] group-hover:h-full transition-all duration-500 delay-100"></span>
              <span className="absolute bottom-0 right-0 w-0 h-[2px] bg-[#1E72BB] group-hover:w-full transition-all duration-500 delay-200"></span>
              <span className="absolute bottom-0 left-0 w-[2px] h-0 bg-[#1E72BB] group-hover:h-full transition-all duration-500 delay-300"></span>

           
              <motion.div
                className="w-15 h-15 flex items-center justify-center rounded-full mb-4 mx-auto"
                whileHover={{ scale: 1.1 }}
                transition={{ type: "spring", stiffness: 300, damping: 12 }}
              >
                <img
                  src={item.icon}
                  alt={item.title}
                  className="w-10 h-10 transition-transform duration-300 group-hover:scale-110"
                />
              </motion.div>

            
              <h3 className="text-lg font-semibold text-gray-900">
                {item.title}
              </h3>

              <p className="mt-2 text-sm text-gray-600">{item.desc}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default CapacityBenefits;
